// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import Api from './Api';
import Backward from './Backward';
import Bolt from './Bolt';
import Calendar from './Calendar';
import CaretDown from './CaretDown';
import CaretLeft from './CaretLeft';
import CaretRight from './CaretRight';
import CaretUp from './CaretUp';
import Chart from './Chart';
import Clipboard from './Clipboard';
import Collapse from './Collapse';
import CreditCard from './CreditCard';
import Door from './Door';
import Download from './Download';
import Drive from './Drive';
import Edgeworker from './Edgeworker';
import ExclamationSign from './ExclamationSign';
import Expand from './Expand';
import Facebook from './Facebook';
import File from './File';
import Filter from './Filter';
import Firebolt from './Firebolt';
import FlowchartAlt from './FlowchartAlt';
import Flowchart from './Flowchart';
import Forward from './Forward';
import Gear from './Gear';
import GooglePlus from './GooglePlus';
import Hamburger from './Hamburger';
import Happy from './Happy';
import Help from './Help';
import InfoSign from './InfoSign';
import Left from './Left';
import Linkedin from './Linkedin';
import List from './List';
import Lock from './Lock';
import Mail from './Mail';
import Minus from './Minus';
import Network from './Network';
import OkSign from './OkSign';
import Ok from './Ok';
import Pause from './Pause';
import Plus from './Plus';
import Refresh from './Refresh';
import Remove from './Remove';
import Reorder from './Reorder';
import ResizeHorizontal from './ResizeHorizontal';
import Retarget from './Retarget';
import Right from './Right';
import Sad from './Sad';
import Search from './Search';
import Shield from './Shield';
import Spectrum from './Spectrum';
import Speech from './Speech';
import Stream from './Stream';
import Time from './Time';
import Twitter from './Twitter';
import Upload from './Upload';
import User from './User';
import Wrench from './Wrench';

export default {
  api: Api,
  backward: Backward,
  bolt: Bolt,
  calendar: Calendar,
  'caret-down': CaretDown,
  'caret-left': CaretLeft,
  'caret-right': CaretRight,
  'caret-up': CaretUp,
  chart: Chart,
  clipboard: Clipboard,
  collapse: Collapse,
  'credit-card': CreditCard,
  door: Door,
  download: Download,
  drive: Drive,
  edgeworker: Edgeworker,
  'exclamation-sign': ExclamationSign,
  expand: Expand,
  facebook: Facebook,
  file: File,
  filter: Filter,
  firebolt: Firebolt,
  'flowchart-alt': FlowchartAlt,
  flowchart: Flowchart,
  forward: Forward,
  gear: Gear,
  'google-plus': GooglePlus,
  hamburger: Hamburger,
  happy: Happy,
  help: Help,
  'info-sign': InfoSign,
  left: Left,
  linkedin: Linkedin,
  list: List,
  lock: Lock,
  mail: Mail,
  minus: Minus,
  network: Network,
  'ok-sign': OkSign,
  ok: Ok,
  pause: Pause,
  plus: Plus,
  refresh: Refresh,
  remove: Remove,
  reorder: Reorder,
  'resize-horizontal': ResizeHorizontal,
  retarget: Retarget,
  right: Right,
  sad: Sad,
  search: Search,
  shield: Shield,
  spectrum: Spectrum,
  speech: Speech,
  stream: Stream,
  time: Time,
  twitter: Twitter,
  upload: Upload,
  user: User,
  wrench: Wrench
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/index.js
// module id = 1010
// module chunks = 1